
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/internship-guarantee-policy",
      function () {
        return require("private-next-pages/next/internship-guarantee-policy.tsx");
      }
    ]);
  